"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
exports.validate = validate;
var _react = _interopRequireWildcard(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _cccisdFormik = require("cccisd-formik");
var _arrowResize = _interopRequireDefault(require("cccisd-icons/arrow-resize4"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _ModuleContent = _interopRequireDefault(require("./ModuleContent.js"));
var _helpers = require("../Pinned/helpers.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var initialValues = exports.initialValues = {
  modules: []
};
function validate(values) {
  var allErrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var assignmentData = arguments.length > 2 ? arguments[2] : undefined;
  var errs = allErrs || {};
  var prefix = values.currentPrefix;
  var currValues = (0, _get2["default"])(values, prefix, {});
  var buildLanguages = (0, _get2["default"])(assignmentData, 'settings.buildLanguages', []);
  var isEnglish = buildLanguages.includes('en');
  var isSpanish = buildLanguages.includes('es');

  // return error if any module has `visibility` selected but not `unlockAfter`
  if (!currValues.isMustTakeInOrder && Array.isArray(currValues === null || currValues === void 0 ? void 0 : currValues.modules)) {
    currValues.modules.forEach(function (m, i) {
      if (['disabled', 'hidden'].includes(m.visibility)) {
        if (!m.unlockAfter || m.unlockAfter === 'placeholder') {
          errs["".concat(prefix, ".modules.").concat(i, ".unlockAfter")] = 'Required';
        }
        if (isEnglish && m.unlockAfter === 'entity' && !m.entityIdEn) {
          errs["".concat(prefix, ".modules.").concat(i, ".entityIdEn")] = 'Required';
        }
        if (isSpanish && m.unlockAfter === 'entity' && !m.entityIdEs) {
          errs["".concat(prefix, ".modules.").concat(i, ".entityIdEs")] = 'Requerido';
        }
      }
    });
  }
  return errs;
}
var Modules = function Modules(_ref) {
  var assignmentData = _ref.assignmentData,
    draggableOffset = _ref.draggableOffset,
    formikBag = _ref.formikBag;
  /*
      `expanded` is index-based, not ID-based:
      {
          0: true,
          1: false,
          ...
      }
  */
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var values = formikBag.values;
  var prefix = values.currentPrefix;
  var currValues = (0, _get2["default"])(values, prefix, {});
  var buildLanguages = (0, _get2["default"])(assignmentData, 'settings.buildLanguages', []);
  var isEnglish = buildLanguages.includes('en');
  var isSpanish = buildLanguages.includes('es');
  function setIsExpanded(index, bool) {
    setExpanded(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, index, bool));
    });
  }
  function collapseAll() {
    setExpanded(currValues.modules.reduce(function (all, curr, index) {
      all[index] = false;
      return all;
    }, {}));
  }
  function addModule(fieldArrayBag) {
    var highestId = currValues.modules.reduce(function (highest, curr) {
      if (highest < parseInt(curr.id, 10)) {
        return parseInt(curr.id, 10);
      }
      return highest;
    }, 0);
    var nextId = highestId + 1;
    fieldArrayBag.push({
      id: nextId,
      surveyHandles: [],
      visibility: 'always',
      unlockAfter: 'placeholder'
    });
    // modulesTouched is dummy key to force Save button to highlight
    fieldArrayBag.form.setFieldTouched('modulesTouched', true);
    (0, _helpers.addPinnedContentModule)(formikBag, nextId - 1);
    setExpanded(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, nextId - 1, false));
    });
  }
  function removeModule(indexToDelete, fieldArrayBag) {
    var original = (0, _get2["default"])(fieldArrayBag.form.values, fieldArrayBag.name, []);
    var updated = [];
    var nextExpanded = {};
    for (var i = 0; i < original.length; i++) {
      if (i === indexToDelete) {
        continue;
      }
      var valToPush = original[i];
      if (i < indexToDelete) {
        nextExpanded[i] = expanded[i];
      } else {
        valToPush.id -= 1;
        nextExpanded[i - 1] = expanded[i];
      }
      updated.push(valToPush);
    }
    fieldArrayBag.form.setFieldValue(fieldArrayBag.name, updated);
    // modulesTouched is dummy key to force Save button to highlight
    fieldArrayBag.form.setFieldTouched('modulesTouched', true);
    (0, _helpers.deletePinnedContentModule)(formikBag, indexToDelete);
    setExpanded(nextExpanded);
  }
  function onModuleDragEnd(result, fieldArrayBag) {
    if (!(result !== null && result !== void 0 && result.destination)) {
      return;
    }
    var indexFrom = result.source.index;
    var indexTo = result.destination.index;
    var original = (0, _get2["default"])(fieldArrayBag.form.values, fieldArrayBag.name, []);
    var updated = [];
    for (var i = 0; i < original.length; i++) {
      var valToPush = original[i];
      if (i === indexTo) {
        valToPush = original[indexFrom];
      }
      // moving item up the list
      else if (indexTo < indexFrom && i > indexTo && i <= indexFrom) {
        if (i > indexTo && i <= indexFrom) {
          valToPush = original[i - 1];
        }
      }
      // moving item down the list
      else if (indexTo > indexFrom && i >= indexFrom && i < indexTo) {
        valToPush = original[i + 1];
      }
      valToPush.id = i + 1;
      updated.push(valToPush);
    }
    fieldArrayBag.form.setFieldValue(fieldArrayBag.name, updated);
    (0, _helpers.movePinnedContentModule)(formikBag, indexFrom, indexTo);
    // modulesTouched is dummy key to force Save button to highlight
    fieldArrayBag.form.setFieldTouched('modulesTouched', true);
  }
  function renderModule(module, index, fieldArrayBag) {
    return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
      key: index,
      draggableId: index + '',
      index: index
    }, function (provided, snapshot) {
      if (snapshot.isDragging) {
        provided.draggableProps.style.left -= draggableOffset.x;
        provided.draggableProps.style.top -= draggableOffset.y;
      }
      var allErrors = (0, _get2["default"])(formikBag, 'errors', {}) || {};
      var hasError = formikBag.submitCount > 0 && Object.keys(allErrors).find(function (k) {
        return k.startsWith("".concat(prefix, ".modules.").concat(index));
      });
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: provided.innerRef
      }, provided.draggableProps, {
        className: "".concat(_style["default"].moduleDraggable, " ").concat(hasError ? _style["default"].hasError : '')
      }), /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: _style["default"].icon
      }, provided.dragHandleProps), /*#__PURE__*/_react["default"].createElement(_arrowResize["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].content
      }, /*#__PURE__*/_react["default"].createElement(_ModuleContent["default"], {
        assignmentData: assignmentData,
        deleteModule: function deleteModule() {
          return removeModule(index, fieldArrayBag);
        },
        formikBag: formikBag,
        hasError: hasError,
        index: index,
        isEnglish: isEnglish,
        isExpanded: expanded[index],
        isSpanish: isSpanish,
        module: module,
        setIsExpanded: setIsExpanded,
        surveys: (0, _get2["default"])(assignmentData, 'currentSurveylistList.surveyList', []) || []
      })));
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
    name: prefix + '.modules'
  }, function (fieldArrayBag) {
    var isModules = Array.isArray(currValues.modules) && currValues.modules.length > 0;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
      onClick: function onClick() {
        return addModule(fieldArrayBag);
      },
      type: "button",
      className: "btn btn-secondary"
    }, /*#__PURE__*/_react["default"].createElement(_plus["default"], {
      spaceRight: true
    }), "Add Module"), isModules && /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
      onBeforeCapture: collapseAll,
      onDragEnd: function onDragEnd(result) {
        return onModuleDragEnd(result, fieldArrayBag);
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
      droppableId: "modules"
    }, function (provided, snapshot) {
      return /*#__PURE__*/_react["default"].createElement("div", _extends({}, provided.droppableProps, {
        ref: provided.innerRef,
        className: _style["default"].modulesDroppable
      }), currValues.modules.map(function (module, index) {
        return renderModule(module, index, fieldArrayBag);
      }), provided.placeholder);
    })));
  });
};
var _default = exports["default"] = Modules;